// The public hero is shared by the initial document and the normal client.
export const homepageContent = Object.freeze({
  heading: 'Social Games for Remote Teams',
  description: 'Games, activities and icebreakers for remote meetings and socials. Play completely online without downloading anything. Choose from our collection of web-based games. Ideal for remote voice and video calls.',
  playLabel: 'Play now',
  playDestination: '/app'
});

// The hero on phones (TEAMBRIDGE_PHONE_HERO, src/util/phoneHero.js), shared by the initial document
// and the client. The screenshot is served by the holiday assets route (lib/seasonal-pages.js), so
// the first paint and the app load the same file. Seasonal (a snowman): swap it in January.
export const homepagePhoneContent = Object.freeze({
  heading: ['Team games for your ', 'next meeting'],
  description: 'Icebreakers and quick games your team plays together on Zoom, Teams or Meet. Nothing to download.',
  image: '/holiday-assets/shots/scribble.webp',
  imageAlt: 'Scribble on TeamBridge: one person draws a snowman while the team guesses'
});

// Match the unchanged published homepage sitemap location.
export const homepageCanonical = 'https://www.teambridge.app/';

// Existing Team monthly offer; root discovery does not change purchase terms.
export const homepageTeamMonthlyOffer = Object.freeze({
  label: 'Team plan · $30 USD/month',
  destination: '/pricing?tb_campaign=h0621_home_team#team-monthly-plan'
});

// With the 2026 pricing on, the hero links to all plans at the Team Annual
// monthly equivalent ($240/year = $20/month); otherwise the Team monthly offer.
export function homepagePlanLink(publicOffers) {
  // Pass-only pricing (TEAMBRIDGE_PRICING_PASS_ONLY): the hero names the Team Event Pass.
  const pass = publicOffers?.passOnly && publicOffers.offers?.EVENT_PASS;
  if (pass?.amount) return {
    label: `${pass.name || 'Team Event Pass'} · $${pass.amount}`,
    destination: '/pricing?tb_campaign=h0621_home_team'
  };
  const annual = publicOffers?.pricing2026 && publicOffers.offers?.TEAM_ANNUAL;
  if (!annual?.amount) return homepageTeamMonthlyOffer;
  // Same campaign tag as the Team monthly button, so homepage-to-pricing visits stay counted; no
  // #team-monthly-plan anchor, because this button sells the annual price.
  return {
    label: `Plans from $${Math.round(annual.amount / 12)}/month`,
    destination: '/pricing?tb_campaign=h0621_home_team'
  };
}